<div class="modal" data-iframe-size>
  <div class="icon">
    <img [src]="warningUrl">
  </div>
  @for (key of Object.keys(errors); track key) {
    <h4 class="title">
      {{ key }}
    </h4>
    <mat-dialog-content>
      <div class="content">
        <div>
          @for (error of errors[key]; track trackByTitle($index, error)) {
            <p>
              {{ error.text }}
            </p>
          }
        </div>
      </div>
    </mat-dialog-content>
  }

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>
